import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

import Backdrop from '~/components/BackdropComponent';
import CircularProgress from '@material-ui/core/CircularProgress';
import { showBlood } from '~/services/bloods';
import Date from '~/components/DateComponent';
import NavBar from './components/NavBar';
import Front from './components/BloodFront';
import Back from './components/BloodBack';
import { errorMessage } from '~/utils/Message';

import { Container, Content } from './styles';

function BloodShow({ item }) {
  const [blood, setBlood] = useState(item);
  const [loading, setLoading] = useState(false);

  const { date, region, front, image, audio, description } = blood;
  const data = [region, image, audio, description];

  const [active, setActive] = useState(null);
  const tab = active ? active : data.findIndex((i) => i !== null);

  const loadData = useCallback(async () => {
    setLoading(true);

    try {
      const { data } = await showBlood(item.id);

      setBlood(data);
    } catch (error) {
      errorMessage(error);
    } finally {
      setLoading(false);
    }
  }, [item.id]);

  useEffect(() => {
    setActive(null);
  }, [item.id]);

  const renderSwitch = useCallback(() => {
    switch (tab) {
      case 0:
        if (region && front) {
          // Região frontal
          return <Front region={region} decrease />;
        }
        // Região posterior
        return <Back region={region} descrease />;

      case 1:
        return (
          image && (
            <img className="blood-image" src={image.url} alt={image.name} />
          )
        );

      case 2:
        return (
          audio && (
            <audio controls className="blood-audio">
              <source src={audio.url} type="audio/mp4" />
              Your browser does not support the audio element.
            </audio>
          )
        );

      case 3:
        return (
          description && <p className="blood-description">{description}</p>
        );

      default:
        break;
    }
  }, [tab, region, image, front, audio, description]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  useEffect(() => {
    renderSwitch();
  }, [renderSwitch]);

  return (
    <Container>
      <Date date={date} />
      <NavBar active={tab} setActive={setActive} data={data} />

      <Content>{renderSwitch()}</Content>

      <Backdrop open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Container>
  );
}

BloodShow.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
};

export default BloodShow;
